<template>
  <ul class="bottom-link__item">
    <h4>{{title}}</h4>
    <li v-for="(item, index) in links" :key="index">
      <a :href="item.href">{{item.text}}</a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    links: Array[Object]
  }
};
</script>
<style lang="less">
@import '../../assets/css/common.less';
.bottom-link__item {
  display: inline-flex;
  flex-direction: column;
  font-family: @family-nomal;
  padding: 0;
  h4 {
    font-size: 14px;
    line-height: 16px;
    color: @font-color-secondary;
    margin: 12px 0;
    font-weight: 900;
  }
  li {
    list-style-type: none;
    height: @link-height;
    line-height: @link-height;
  }
  li a {
    font-size: 12px;
    color: @font-color-link;
    margin:0.5em 0;
    // font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottom/comp-link-item.vue